import { defineMessage } from "react-intl";

export const MATERIAL_SYMBOLS_CODEPOINTS_URL =
  "https://raw.githubusercontent.com/google/material-design-icons/master/variablefont/MaterialSymbolsOutlined%5BFILL%2CGRAD%2Copsz%2Cwght%5D.codepoints";

/** @typedef {"materialSymbols" | "internal"} IconTypeValue */

/**
 * @typedef {{name: import("react-intl").MessageDescriptor, type: IconTypeValue, prefix: string}} IconType
 */

/** @type {IconType[]} */
export const ICON_TYPES_LIST = [
  {
    name: defineMessage({ defaultMessage: "Material Symbols" }),
    type: "materialSymbols",
    prefix: "ms_",
  },
  {
    name: defineMessage({ defaultMessage: "Icônes internes" }),
    type: "internal",
    prefix: "sf_",
  },
];

export const ICON_TYPES_MAP = new Map(
  ICON_TYPES_LIST.map((item) => [item.type, item]),
);

export const ICON_TYPES_PREFIX_MAP = new Map(
  ICON_TYPES_LIST.map((item) => [item.prefix, item]),
);

/**
 * @typedef {{icon: string, label: import("react-intl").MessageDescriptor, element: JSX.Element}} InternalIcon
 */

/** @type {InternalIcon[]} */
export const INTERNAL_ICONS_LIST = [
  {
    icon: "sf_search",
    element: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100"
        height="100"
        viewBox="0 -960 960 960">
        <path
          fill="currentColor"
          d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"
        />
      </svg>
    ),
    label: defineMessage({ defaultMessage: "Rechercher" }),
  },
  {
    icon: "sf_facebook",
    element: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M8.85625 23.9954V11.4515H6.75V8.46638H8.85625V7.46479C8.85069 6.4968 9.00549 5.53472 9.3142 4.61843C9.60044 3.72764 10.1025 2.92334 10.7746 2.27885C11.3492 1.74013 12.035 1.33725 12.7824 1.0993C13.4865 0.86698 14.2226 0.749382 14.9632 0.750873C15.7322 0.740566 16.4997 0.821529 17.25 0.992178L17.0888 4.13122C16.672 4.04231 16.247 3.99831 15.821 3.99998C15.4185 3.98194 15.0177 4.06375 14.6537 4.23834C14.2896 4.41292 13.9734 4.67497 13.7325 5.00156C13.295 5.67082 13.0773 6.46258 13.1105 7.26418V8.47089H16.3356V11.456H13.1464V24L8.85625 23.9954Z"
          fill="currentColor"
        />
      </svg>
    ),
    label: defineMessage({ defaultMessage: "Facebook" }),
  },
  {
    icon: "sf_instagram",
    element: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 8.00033C14.2029 8.00033 15.9997 9.79705 15.9997 12C15.9997 14.2029 14.2029 15.9997 12 15.9997C9.79705 15.9997 8.00033 14.2029 8.00033 12C8.00033 9.79705 9.79705 8.00033 12 8.00033ZM12 18.1557C15.406 18.1557 18.1557 15.406 18.1557 12C18.1557 8.59403 15.406 5.84425 12 5.84425C8.59403 5.84425 5.84425 8.59403 5.84425 12C5.84425 15.406 8.59403 18.1557 12 18.1557ZM18.4057 7.03165C19.2025 7.03165 19.8431 6.39108 19.8431 5.59427C19.8431 4.79746 19.2025 4.15689 18.4057 4.15689C17.6089 4.15689 16.9683 4.79746 16.9683 5.59427C16.9683 6.39108 17.6089 7.03165 18.4057 7.03165ZM11.1588 2.15127C11.4708 2.15429 11.755 2.15705 12 2.15705C12.245 2.15705 12.5292 2.15429 12.8412 2.15127C14.7573 2.13268 17.7205 2.10394 19.0775 2.64139C19.6244 2.86012 20.0306 3.12572 20.4524 3.54756C20.8743 3.9694 21.1399 4.37562 21.3586 4.92245C21.8961 6.2795 21.8673 9.24266 21.8487 11.1588C21.8457 11.4708 21.8429 11.755 21.8429 12C21.8429 12.245 21.8457 12.5292 21.8487 12.8412C21.8673 14.7573 21.8961 17.7205 21.3586 19.0775C21.1399 19.6244 20.8743 20.0306 20.4524 20.4524C20.0306 20.8743 19.6244 21.1399 19.0775 21.3586C17.7205 21.8961 14.7573 21.8673 12.8412 21.8487C12.5292 21.8457 12.245 21.8429 12 21.8429C11.755 21.8429 11.4708 21.8457 11.1588 21.8487C9.24266 21.8673 6.2795 21.8961 4.92245 21.3586C4.37562 21.1399 3.9694 20.8743 3.54756 20.4524C3.12572 20.0306 2.86012 19.6244 2.64139 19.0775C2.10394 17.7205 2.13268 14.7573 2.15127 12.8412C2.15429 12.5292 2.15705 12.245 2.15705 12C2.15705 11.755 2.15429 11.4708 2.15127 11.1588C2.13268 9.24266 2.10394 6.2795 2.64139 4.92245C2.86012 4.37562 3.12572 3.9694 3.54756 3.54756C3.9694 3.12572 4.37562 2.86012 4.92245 2.64139C6.2795 2.10394 9.24266 2.13268 11.1588 2.15127ZM23.9995 12.6209C23.9993 12.4141 23.999 12.2072 23.999 12C23.999 11.7928 23.9993 11.5859 23.9995 11.3791C24.0012 9.93317 24.0029 8.4962 23.9209 7.04728C23.8272 5.12556 23.3897 3.42257 21.9836 2.01644C20.5774 0.610302 18.8744 0.172837 16.9527 0.0790949C15.5038 -0.00291915 14.0669 -0.00122107 12.6209 0.000487617C12.4142 0.000731966 12.2072 0.000976532 12 0.000976532C11.7928 0.000976532 11.5858 0.000731966 11.3791 0.000487617C9.93315 -0.00122107 8.49619 -0.00291915 7.04728 0.0790949C5.12556 0.172837 3.42257 0.610302 2.01644 2.01644C0.610302 3.42257 0.172837 5.12556 0.0790949 7.04728C-0.00291915 8.49619 -0.00122107 9.93315 0.000487617 11.3791C0.000731966 11.5858 0.000976532 11.7928 0.000976532 12C0.000976532 12.2072 0.000731966 12.4142 0.000487617 12.6209C-0.00122107 14.0669 -0.00291915 15.5038 0.0790949 16.9527C0.172837 18.8744 0.610302 20.5774 2.01644 21.9836C3.42257 23.3897 5.12556 23.8272 7.04728 23.9209C8.28062 23.9907 9.5053 23.9999 10.7342 24C10.7518 24 10.7693 24 10.7868 24C10.9841 24 11.1815 23.9997 11.3791 23.9995C11.5859 23.9993 11.7928 23.999 12 23.999C12.2072 23.999 12.4141 23.9993 12.6209 23.9995C12.8185 23.9997 13.0159 24 13.2132 24C13.2307 24 13.2482 24 13.2658 24C14.4947 23.9999 15.7194 23.9907 16.9527 23.9209C18.8744 23.8272 20.5774 23.3897 21.9836 21.9836C23.3897 20.5774 23.8272 18.8744 23.9209 16.9527C24.0029 15.5038 24.0012 14.0668 23.9995 12.6209Z"
          fill="currentColor"
        />
      </svg>
    ),
    label: defineMessage({ defaultMessage: "Facebook" }),
  },
  {
    icon: "sf_linkedin",
    element: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <g clipPath="url(#clip0_3479_13641)">
          <path
            d="M21.5319 0.000244141H1.71812C0.769303 0.000244141 0 0.770144 0 1.71946V22.2808C0 23.2304 0.769303 24 1.71812 24H21.5319C22.4807 24 23.25 23.2304 23.25 22.2808V1.71946C23.25 0.770144 22.4807 0.000244141 21.5319 0.000244141ZM7.0477 20.0904H3.53597V9.25321H7.0477V20.0904ZM5.29183 7.77353H5.26882C4.09047 7.77353 3.32822 6.9413 3.32822 5.90134C3.32822 4.83809 4.11379 4.02884 5.31485 4.02884C6.5159 4.02884 7.25575 4.83777 7.27846 5.90134C7.27846 6.9413 6.51621 7.77353 5.29153 7.77353H5.29183ZM19.7104 20.0904H16.1989V14.2928C16.1989 12.8358 15.6908 11.8421 14.4197 11.8421C13.4498 11.8421 12.8719 12.5122 12.6179 13.1594C12.5252 13.391 12.5022 13.7146 12.5022 14.0385V20.0904H8.99044C8.99044 20.0904 9.03647 10.2699 8.99044 9.25321H12.5022V10.7883C12.9686 10.0499 13.803 8.99888 15.6668 8.99888C17.9772 8.99888 19.7097 10.5478 19.7097 13.8764V20.0904H19.7104Z"
            fill="currentColor"
          />
        </g>

        <defs>
          <clipPath id="clip0_3479_13641">
            <rect width="23.25" height="24" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    ),
    label: defineMessage({ defaultMessage: "Facebook" }),
  },
  {
    icon: "sf_camer_video",
    element: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none">
        <path
          d="M15.1625 19H9.7125L10.2125 17H14.6625L15.1625 19ZM15.4375 15H9.4375C8.05417 15 6.875 14.5125 5.9 13.5375C4.925 12.5625 4.4375 11.3833 4.4375 10C4.4375 8.61667 4.925 7.4375 5.9 6.4625C6.875 5.4875 8.05417 5 9.4375 5H15.4375C16.8208 5 18 5.4875 18.975 6.4625C19.95 7.4375 20.4375 8.61667 20.4375 10C20.4375 11.3833 19.95 12.5625 18.975 13.5375C18 14.5125 16.8208 15 15.4375 15ZM12.4375 12C12.9875 12 13.4583 11.8042 13.85 11.4125C14.2417 11.0208 14.4375 10.55 14.4375 10C14.4375 9.45 14.2417 8.97917 13.85 8.5875C13.4583 8.19583 12.9875 8 12.4375 8C11.8875 8 11.4167 8.19583 11.025 8.5875C10.6333 8.97917 10.4375 9.45 10.4375 10C10.4375 10.55 10.6333 11.0208 11.025 11.4125C11.4167 11.8042 11.8875 12 12.4375 12ZM17.9375 9C17.6542 9 17.4167 8.90417 17.225 8.7125C17.0333 8.52083 16.9375 8.28333 16.9375 8C16.9375 7.71667 17.0333 7.47917 17.225 7.2875C17.4167 7.09583 17.6542 7 17.9375 7C18.2208 7 18.4583 7.09583 18.65 7.2875C18.8417 7.47917 18.9375 7.71667 18.9375 8C18.9375 8.28333 18.8417 8.52083 18.65 8.7125C18.4583 8.90417 18.2208 9 17.9375 9ZM20.4375 21V19H17.2125L16.6875 16.9C18.3375 16.6167 19.7083 15.8292 20.8 14.5375C21.8917 13.2458 22.4375 11.7333 22.4375 10C22.4375 8.05 21.7583 6.39583 20.4 5.0375C19.0417 3.67917 17.3875 3 15.4375 3H9.4375C7.4875 3 5.83333 3.67917 4.475 5.0375C3.11667 6.39583 2.4375 8.05 2.4375 10C2.4375 11.7333 2.98333 13.2458 4.075 14.5375C5.16667 15.8292 6.5375 16.6167 8.1875 16.9L7.6625 19H4.4375V21H20.4375ZM12.4375 14C11.3375 14 10.3958 13.6083 9.6125 12.825C8.82917 12.0417 8.4375 11.1 8.4375 10C8.4375 8.9 8.82917 7.95833 9.6125 7.175C10.3958 6.39167 11.3375 6 12.4375 6C13.5375 6 14.4792 6.39167 15.2625 7.175C16.0458 7.95833 16.4375 8.9 16.4375 10C16.4375 11.1 16.0458 12.0417 15.2625 12.825C14.4792 13.6083 13.5375 14 12.4375 14Z"
          fill="currentColor"
        />
      </svg>
    ),
    label: defineMessage({ defaultMessage: "Facebook" }),
  },
];

export const INTERNAL_ICONS_MAP = new Map(
  INTERNAL_ICONS_LIST.map((item) => [item.icon, item]),
);
